import {
    FETCHED_AGE_GROUPS, 
    REVIEW_SEARCH_BY_AUTHOR,
    FETCHED_REVIEWS_BY_SEARCH_TERMS,
    CLEAR_REVIEWS_SEARCH_FILTER
} from './types';
import update from 'immutability-helper/index';
import _sortBy from 'lodash/sortBy';

const INITIAL_STATE = {
    allAgeGroups: [],
    reviewSearchCriteria: '',
    allReviewsBySearchTerms: [],
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCHED_AGE_GROUPS:

            let sortedAgeGroups = _sortBy(action.payload, 'display_name');

            return update(state, {
                allAgeGroups: {$set: sortedAgeGroups}
            });

        case FETCHED_REVIEWS_BY_SEARCH_TERMS:

            return update(state, {
                allReviewsBySearchTerms: {$set: action.payload},
            });

        case REVIEW_SEARCH_BY_AUTHOR:

            return update(state, {
                reviewSearchCriteria: {$set: action.payload.searchBy},
            });

        case CLEAR_REVIEWS_SEARCH_FILTER:

            return update(state, {
                allReviewsBySearchTerms: {$set: []},
                reviewSearchCriteria: {$set: ''}
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/reviews/reducer.js